import { useMemo } from 'react';
import { addMediaImportFilesPopUpActions } from '@wix/bi-logger-media-data/v2';
import { bi } from '../../../services/loggers/bi';

export const useTrackFilesImportPopup = () =>
  useMemo(
    () => ({
      trackAddMediaImportFilesPopUpActions: ({ isOpen, tabName }) =>
        bi.logger().report(addMediaImportFilesPopUpActions({ target: isOpen ? 'opened' : 'closed', tabName })),
    }),
    [],
  );
